up.compiler('.note-foldable-diff', function(foldableDiff) {
  var visibleLinesAroundChanges = 3;
  var list = foldableDiff.querySelector('.diff>ul');

  var items = list.querySelectorAll('li.ins, li.del, li.unchanged');
  var unchangedItemSequence = [];
  var changeDetected = false;

  up.util.each(items, function(item, index) {
    if (isUnchanged(item)){
      unchangedItemSequence.push(item);
    } else {
      fold(unchangedItemSequence, changeDetected, true);
      unchangedItemSequence = [];
      changeDetected = true;
    }
  });

  // fold the last sequence
  fold(unchangedItemSequence, true, false);

  function isUnchanged(item) {
    return item.classList.contains('unchanged');
  }

  // All items are unchanged lines.
  // It has to be determined
  function fold(items, changeBeforeUnfold, changeAfterUnfold) {
    if (items.length == 0) return;

    var startIndex;
    var itemsToHide;

    // if there has been a change before, we have to show some context;
    // otherwise we're at the beginning of the diff
    if (changeBeforeUnfold){
      startIndex = visibleLinesAroundChanges;
    } else {
      startIndex = 0;
    }

    // we also have to provide context for the following change that triggered the fold;
    // just at the end of the diff we don't have to show context
    if (changeAfterUnfold) {
      itemsToHide = items.slice(startIndex, -visibleLinesAroundChanges);
    } else {
      itemsToHide = items.slice(startIndex);
    }

    if (itemsToHide.length > 0) {
      var unfoldModifier = '';
      if (changeBeforeUnfold) unfoldModifier += '.-change-before';
      if (changeAfterUnfold) unfoldModifier += '.-change-after'

      var unfoldElement = up.element.affix(items[startIndex], 'beforebegin', `.note-foldable-diff--unfold${unfoldModifier}`, { text: '...' });

      up.util.each(itemsToHide, function(item, index) {
        up.element.hide(item);
      });

      // register unfold action: show hidden lines and remove unfold
      up.on(unfoldElement, 'click', function(event, unfoldElement, data) {
        up.util.each(itemsToHide, function(item, index) {
          up.element.show(item);
        });
        unfoldElement.remove()
      });
    }
  }

});
